
import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
import { mapActions, mapGetters } from 'vuex';
import QuestionItem from '@/components/QuestionItem/index.vue';
import { GetQuestionParams } from '@/config/types';
import { LineCustom, Wrapper } from './styles';

export default Vue.extend({
  components: {
    ValidationObserver,
    QuestionItem,
    LineCustom,
    Wrapper,
  },
  props: ['cdEvidence'],
  data() {
    return {
      questions: [],
      routes: [],
      userLoged: JSON.parse(sessionStorage.getItem('userLogged') as string),
    };
  },
  computed: mapGetters(['getQuestions']),
  methods: mapActions(['getQuestionByEvidenceId']),
  async created() {
    this.$store.commit('setRoutes', this.routes);

    const loader = this.$loading.show({
      container: this.$refs.formContainer,
    });

    await this.getQuestionByEvidenceId({
      tokenKey: this.userLoged.company.stKey,
      evidenceId: this.cdEvidence,
    } as GetQuestionParams);

    loader.hide();
  },
});
